import { atom } from 'jotai';

export const wrapperSizeAtom = atom({ x: 0, y: 0 });
